export const subtitles = {
    "1": {
        "startTime": 1.444,
        "endTime": 7.7219999999999995,
        "transcript": "Tan'gurraullemteńi-gga tamaani imkut angayuqaamta",
        "translation": "When we were boys back then, our parents"
    },
    "2": {
        "startTime": 8.758,
        "endTime": 18.247,
        "transcript": "Angayuqaagma anerteqlermegni qaygimun tau͡gaam cinguqtaaralriatun ayuqetullrukiignga.",
        "translation": "When my parents were alive, it's like they encouraged me to go to the community house."
    },
    "3": {
        "startTime": 18.646,
        "endTime": 21.69,
        "transcript": "Qaygisqumaurelua.",
        "translation": "They wanted me to partake in the community house."
    },
    "4": {
        "startTime": 22.398,
        "endTime": 29.909,
        "transcript": "Tau͡ga-llu niillukek taukuk narurrnanrilamkek-llu angayuqaagka taukuk.",
        "translation": "And so I obeyed them, since I did not go against my parents' wishes."
    },
    "5": {
        "startTime": 31.08,
        "endTime": 41.047,
        "transcript": "Tau͡gaam nutaraulkiilagnek ak'allaulutek piagnek narurtaarpegnakek cuungnatullruunga.",
        "translation": "But since they were not young, since they were old, I lived without going against their wishes."
    },
    "6": {
        "startTime": 41.059,
        "endTime": 46.992,
        "transcript": "Tau͡gan' pisqumatiik aturluku qaygimun tau͡ga ag'aqlua.",
        "translation": "According to their request, I would go to the community house."
    },
    "7": {
        "startTime": 47.798,
        "endTime": 55.52,
        "transcript": "Qaygimun tau͡gken it'raqamta cugyakapiareluni qaug'utuumarmi.",
        "translation": "Yet when we entered the community house, there was a great many people all the way inside."
    },
    "8": {
        "startTime": 55.532,
        "endTime": 65.755,
        "transcript": "Man'a-llu nakirnermeng pitukiit man'a kanaggun pugyarangqerrluni mayuryarauluni kanaggun.",
        "translation": "And the area here that they call the side wall had an entrance from below where you would go up from down there."
    },
    "9": {
        "startTime": 65.76,
        "endTime": 69.738,
        "transcript": "Au͡gna-ll' kialirneq egkumeng pituluku.",
        "translation": "And they would call the area further inside the back wall."
    },
    "10": {
        "startTime": 69.746,
        "endTime": 75.357,
        "transcript": "Ukalirneq-llu ualirnermeng pituluku.",
        "translation": "And they would call this area, the area toward the door."
    },
    "11": {
        "startTime": 75.841,
        "endTime": 80.519,
        "transcript": "Cugyakapiarnaurtuq man'a qaygim ilua.",
        "translation": "There would be a great many people inside the community house."
    },
    "12": {
        "startTime": 80.532,
        "endTime": 92.51,
        "transcript": "Qau͡gna-llu waten atakuyartumi pilriani calinriqerrluteng qaygimun ag'aqata imkut angutet enmequrayuitellruameng-llu.",
        "translation": "And the area inside close to the evening like this, the men stopped working when the men went to the community house since they didn't always stay in the houses."
    },
    "13": {
        "startTime": 92.858,
        "endTime": 96.436,
        "transcript": "Qaygi tau͡ga enkepiarluku enekluku.",
        "translation": "The community house was their real home."
    },
    "14": {
        "startTime": 96.566,
        "endTime": 105.522,
        "transcript": "Ukuk-gga angutngurtellriik, wanigg' ualirnermi uani iqukacagarmi uitaluni",
        "translation": "As for the two old men, [one] stayed here toward the door at the very end"
    },
    "15": {
        "startTime": 105.728,
        "endTime": 110.573,
        "transcript": "Cali ikna iqukacagarmi cali uitaluni.",
        "translation": "And [the other] across there was at the very end."
    },
    "16": {
        "startTime": 110.592,
        "endTime": 115.192,
        "transcript": "Taukuk qaneryarameng egelracilriik.",
        "translation": "They brought forth traditional wisdom."
    },
    "17": {
        "startTime": 115.732,
        "endTime": 125.121,
        "transcript": "Civunerkiutulik taukuk tamarmeng una wani qanrraarcelluku ukalirnermelnguq",
        "translation": "Both of those who instructed on the future, after having the one on this side speak"
    },
    "18": {
        "startTime": 125.321,
        "endTime": 132.054,
        "transcript": "Ayuqucirkaat una qanrutkarkartek pavqaarluku",
        "translation": "After bringing what they needed to say about how they should be"
    },
    "19": {
        "startTime": 132.959,
        "endTime": 138.337,
        "transcript": "Waten cuullerkaat ayuqellerkaat qanrutekluku.",
        "translation": "He spoke about how they should live, and how they should be."
    },
    "20": {
        "startTime": 140.075,
        "endTime": 146.287,
        "transcript": "Tau͡ga-ll' taqngan ik'um call' kituggluku akiqlian.",
        "translation": "Then when he was done, the one across fixed it."
    },
    "21": {
        "startTime": 146.632,
        "endTime": 160.498,
        "transcript": "Waten cuusqelluku cuk. Qasgimiungermeng, ataunge'rmeng, irnialing'e'rmeng taukuk qaneryarakek canrilkenritait.",
        "translation": "They said a person should live like this. Though they lived in the community house, were fathers, had many children, the didn't disregard what they said."
    },
    "22": {
        "startTime": 160.879,
        "endTime": 165.257,
        "transcript": "Nepariataquq qaygi taukuk qanngaqagneng.",
        "translation": "The community house would be quiet when they spoke."
    },
    "23": {
        "startTime": 167.051,
        "endTime": 178.085,
        "transcript": "Waten cuullerkaata tungii quyinginaqluki cuugusqevkenaki taukuk qantulik qantuuk.",
        "translation": "About how they should live, the two speakers would say that they shouldn't be haughty people."
    },
    "24": {
        "startTime": 178.091,
        "endTime": 180.368,
        "transcript": "Quyingnaqevkenata-gguq.",
        "translation": "They said we shouldn't be haughty."
    },
    "25": {
        "startTime": 180.593,
        "endTime": 191.482,
        "transcript": "Imna-gguq tau͡gaam un'a enqakluku nateq, nateq un'a waten caranglliraqelria tutmaqiit.",
        "translation": "They said, however, to remember the floor, the floor down there where they trod that has grass strewn about it."
    },
    "26": {
        "startTime": 192.008,
        "endTime": 201.108,
        "transcript": "Enqakluku-gguq wangkuta cuuniartukut tamana quyingnaqevkenata.",
        "translation": "They said that we should live remembering that, trying not to be haughty."
    },
    "27": {
        "startTime": 202.029,
        "endTime": 206.696,
        "transcript": "Tau͡ga-llu-gguq tau͡gatnaureluta pikumta",
        "translation": "Then they said that if we do that"
    },
    "28": {
        "startTime": 207.147,
        "endTime": 221.08,
        "transcript": "Cali makut civumteńi cuurtellret teggenrurtellriit makut cali tau͡ga-i ikayungnaqureluki uumeng piyuumiutiitneng.",
        "translation": "Also, they said that we should try to help these elders that were born before us with what they want."
    },
    "29": {
        "startTime": 221.26,
        "endTime": 235.893,
        "transcript": "Qang'a-llu cali ukuk teggenrurtellriik nulirqelriit mermeng enuqitevkarpekgnakek ullakarlukuk nallunrilkumtekek cali mertarlukek.",
        "translation": "Or also, we should not let an elderly couple lack water, go to them if we know them, and get water for them."
    },
    "30": {
        "startTime": 236.9,
        "endTime": 241.822,
        "transcript": "Cali cakmena amiiga kituggnarqekan kituggluku.",
        "translation": "Also, if their door below needs fixing, to fix it."
    },
    "31": {
        "startTime": 243.145,
        "endTime": 256.423,
        "transcript": "Tua-ll' imkut waten tan'gurrarnek atanqiyuitut ataurteng'e'rmeng maani qaygim iluani niitellrek.",
        "translation": "Then, they do not await boys like this even though they've become fathers from what we heard of the two in the community house."
    },
    "32": {
        "startTime": 257.242,
        "endTime": 270.142,
        "transcript": "Tan'gurraat atanqevkenaki una ataurrnge'rmi-llu irniangqeng'e'rmi-llu malrugneng taukuk qaneryarak maligtaquqapiggluku maligtaquaqaat.",
        "translation": "They didn't wait for boys, though he became a father and had two children, they would completely follow their traditional wisdom."
    },
    "33": {
        "startTime": 270.744,
        "endTime": 276.539,
        "transcript": "Tau͡gamtellu ayuqenrilamta wangkuta cugni",
        "translation": "Then, since we people are not the same"
    },
    "34": {
        "startTime": 277.503,
        "endTime": 292.359,
        "transcript": "Ayuqenrilamta qanellrak taukuk iliin, cuum iliin tau͡ga-i imutun tangenrilngurcetun niitellrunilngurcetun-llu ayuqluku tau͡ga piarkaulliniluku.",
        "translation": "Since we are no the same, some people would regard what they said as if they didn't see or hear it."
    },
    "35": {
        "startTime": 294.387,
        "endTime": 301.231,
        "transcript": "Tau͡gaten-am tauna qanruteknauraak tau͡gaten ayuqelria.",
        "translation": "They would speak like that about one who was like that."
    },
    "36": {
        "startTime": 301.482,
        "endTime": 308.993,
        "transcript": "Ingna-gguq tekilluku cuungaituq una, Cuugungaituq.",
        "translation": "They said that he will not live to that day, will not be Cup'ik."
    },
    "37": {
        "startTime": 310.108,
        "endTime": 321.153,
        "transcript": "Tau͡gken imna qaneryarartek cali maligtaqustii tamana murilkeqapiggluku murilkellinivagaqluku tamaani qaygim iluanelnguum.",
        "translation": "However, the one in the community house would closely observe the one that obeyed their traditional wisdom."
    },
    "38": {
        "startTime": 321.856,
        "endTime": 334.0,
        "transcript": "Qaneryarameng maligtaqustii, maligtaqusteqapiaraa waten ak'arrarnun anerteqerciqniluku.",
        "translation": "They said that a person who follows traditional wisdom, completely follows it, will live for quite a long time."
    },
    "39": {
        "startTime": 334.675,
        "endTime": 343.764,
        "transcript": "Imumeng anernera uyungekanilriatun ayuqeciqniluku maligtaqulluni tauna pikan.",
        "translation": "They said that it will be like his breath \"squats down [more firmly]\" if he is obedient."
    },
    "40": {
        "startTime": 343.769,
        "endTime": 351.88,
        "transcript": "Ilamineng-llu acivarciyuunani, ilamineng-llu waten upussakiyuunani.",
        "translation": "And he doesn't bring down those around him, and he doesn't speak unfavorably about those around him."
    },
    "41": {
        "startTime": 351.896,
        "endTime": 363.285,
        "transcript": "Ayuqluki ayagyugarungraata, mik'lengraata ayuqluki tau͡ga pisqeńauraat tau͡gaten cuk tauna tukuk qanelriik.",
        "translation": "The same for the young people, and the same for small children, those speakers would tell that person do be like that."
    },
    "42": {
        "startTime": 366.513,
        "endTime": 371.113,
        "transcript": "Tau͡ga-ll' ilumuunganani tau͡ga ayuqaquq.",
        "translation": "So, it seems that it's true."
    },
    "43": {
        "startTime": 372.386,
        "endTime": 385.197,
        "transcript": "Tangrriu makut uka-i cuullemni Qissunameng ayaglua tau͡ga camaken imarpiim cińiineng Qissunameng ayaglua cuullemni",
        "translation": "Look, in my life when I traveled from Qissunaq down there, when I traveled from Qissunaq on the coast of the sea in my life"
    },
    "44": {
        "startTime": 385.66,
        "endTime": 391.116,
        "transcript": "Cali tau͡ga cuurtellrulrua tau͡gani.",
        "translation": "I was also born there."
    },
    "45": {
        "startTime": 391.472,
        "endTime": 403.361,
        "transcript": "Ikamraquyaurrnemkun-llu agayulirtem angllurcicanga, tau͡gaken ayaglua angllullemneng ikamraquyaurrnemkun",
        "translation": "As soon I started travling by sled when that priest baptized me, since my baptism then as soon as I started traveling by sled"
    },
    "46": {
        "startTime": 403.498,
        "endTime": 408.898,
        "transcript": "Tau͡gaken al'rrakunka tau͡ga nallunaunateng taum kengliineng.",
        "translation": "Since then, my age has been clear from that time."
    },
    "47": {
        "startTime": 414.189,
        "endTime": 422.033,
        "transcript": "Tau͡ga-ll' tua-i taum cali atama qanrutnauraanga",
        "translation": "Then my father would also tell me"
    },
    "48": {
        "startTime": 422.96,
        "endTime": 430.083,
        "transcript": "Waten pairyartaqevkenaki pisqelluki angurrlugmeng waten nunat ukut.",
        "translation": "He told me to never go to these villages like this."
    },
    "49": {
        "startTime": 430.66,
        "endTime": 437.082,
        "transcript": "Naugga imu cacuaqeratkut-llu ilait, ilait qenqerrluteng.",
        "translation": "You know how when some do insignificant things to us, they get angry."
    },
    "50": {
        "startTime": 437.288,
        "endTime": 443.5,
        "transcript": "Waten tau͡ga kiumataqelriit taumeng caqertemeggneng tauna atuusqevkenaku.",
        "translation": "They answer to those who do things to them not to use it."
    },
    "51": {
        "startTime": 443.845,
        "endTime": 448.0,
        "transcript": "Aturluku pisqevkenii, cuusqevkenii.",
        "translation": "He told me to live without using it."
    },
    "52": {
        "startTime": 448.818,
        "endTime": 458.451,
        "transcript": "Nutaan cali arnaukan nutaan tau͡ga kiuqeryugnaipallaarluku tauna qaill' eq'uklua pikan.",
        "translation": "Especially if she's a woman, I should not reply [badly] to her if she treats me badly."
    },
    "53": {
        "startTime": 458.661,
        "endTime": 464.539,
        "transcript": "Kiuqeryugnaunaku ulurluku pisqellua.",
        "translation": "He told me to turn away from her without replying."
    },
    "54": {
        "startTime": 464.762,
        "endTime": 475.873,
        "transcript": "Tau͡ga-llu-gguq taum pitatma, wii pitatma pirrlainarpakaquma, pirrlainarpakaqanga tau͡gaten",
        "translation": "Then he said that if my age-mate, if I do that from my age-mate, if he keeps doing that to me"
    },
    "55": {
        "startTime": 477.232,
        "endTime": 482.643,
        "transcript": "Nialiak kinguvaralua, naliak-llu picuilkellua",
        "translation": "One of them pushing me back, and one of them saying I'm not a good hunter"
    },
    "56": {
        "startTime": 482.966,
        "endTime": 496.766,
        "transcript": "Kinguvaralua pikan, qang'a-llu caitnilua naliatneng tayim' piciqanga picuilkellua, caitnilua-llu, carrlugaitnilua.",
        "translation": "If he pushes me back, also saying I have nothing, one of them may say that I'm not a good hunter, and I have nothing, no little thing."
    },
    "57": {
        "startTime": 498.312,
        "endTime": 502.778,
        "transcript": "Arcaayaguskumteggu nutaan tauna kiusqelluku.",
        "translation": "He said that if we can't take him anymore that we should then reply."
    },
    "58": {
        "startTime": 502.954,
        "endTime": 508.82,
        "transcript": "Piyugtacimtun kiusqelluku uuma atama tau͡gaten alerquatullruanga.",
        "translation": "My father used to instruct me like that, to reply with anything I want."
    },
    "59": {
        "startTime": 510.138,
        "endTime": 517.226,
        "transcript": "Tau͡ga-i-gguq taum pistellernaama taqciqaanga taum tau͡gaten kiukumni.",
        "translation": "He said that the one who picked on me will stop if I answer him like that."
    },
    "60": {
        "startTime": 518.255,
        "endTime": 523.821,
        "transcript": "Tau͡ga-am murilkurallemni ilumuungatnaurtuq cali tauna.",
        "translation": "In my observation, that would seem to be true as well."
    },
    "61": {
        "startTime": 525.092,
        "endTime": 538.232,
        "transcript": "Wangkuta tang ayagyugarni ak'a ugg'un tau͡gaam teggnemteggun eglerqurallrulriakut.",
        "translation": "You see, a long time ago, we young people only went forth through our elders."
    },
    "62": {
        "startTime": 538.865,
        "endTime": 543.942,
        "transcript": "Taukuk tua pirpapaqiarelukek civunermeng qantulik.",
        "translation": "They held the two who spoke about the future in very high regard."
    },
    "63": {
        "startTime": 544.066,
        "endTime": 555.211,
        "transcript": "Wanigga-llu tamana qaneryaraagneng ilii maa-i taiguralrianga au͡gaken yaaqvaneng taiguralrianga",
        "translation": "And one of their traditional wisdom, I was coming here from far over there, I was coming"
    },
    "64": {
        "startTime": 555.221,
        "endTime": 564.432,
        "transcript": "Kiitau͡gani makut maa-i waten ellirtuq: man'a kiartelqa eneneng allakauqapiaralrianeng makuneng pitangluni.",
        "translation": "Eventually it became like this: when I looked around, there were completely different houses."
    },
    "65": {
        "startTime": 565.519,
        "endTime": 573.519,
        "transcript": "Nevurrlainarneng enengqerrluteng muragaq aturluku enmeng iluanun.",
        "translation": "They had houses made completely of sod, using wood inside their houses."
    },
    "66": {
        "startTime": 573.837,
        "endTime": 581.703,
        "transcript": "Evek cali man'a aturluku. Nevuq cali aturluku enmeggnun maqarqutekluku.",
        "translation": "They also used grass. They also used sod to insulate their houses."
    },
    "67": {
        "startTime": 581.953,
        "endTime": 589.92,
        "transcript": "Cameng-llu tau͡ga tamakuneng tua cali imkut arnait uitayuitqapiggluteng.",
        "translation": "And their women were absolutely not sedentary."
    },
    "68": {
        "startTime": 589.986,
        "endTime": 594.353,
        "transcript": "Imkuneng caneng taququrluteng.",
        "translation": "They made various things."
    },
    "69": {
        "startTime": 594.41,
        "endTime": 601.032,
        "transcript": "Waten enmi uitakuneng evegneng atlilirluki, curuqluki-llu caggluki.",
        "translation": "If they're in the house, they put grass underneath, and spread them out for matting."
    },
    "70": {
        "startTime": 601.039,
        "endTime": 607.128,
        "transcript": "Wagg'uq makut naqtat, imkut takliriluki curuneng pituluki.",
        "translation": "They called those naqtat, the ones they made long and used for matting."
    },
    "71": {
        "startTime": 608.422,
        "endTime": 617.755,
        "transcript": "Tau͡gamtellu man'a enmeng ilua tamakuneng tangniqnaurtut kapuyukaareneng kapuqurluteng.",
        "translation": "Then inside their house, it would be beautiful with those stuck in with little tack-like things."
    },
    "72": {
        "startTime": 617.826,
        "endTime": 621.293,
        "transcript": "Ena-ll' tamana ataucimeng cungqerpegnani.",
        "translation": "And there wasn't just one person in that house."
    },
    "73": {
        "startTime": 621.3,
        "endTime": 626.967,
        "transcript": "Una wanigg' cungqercecumauq akuliik una tamakucineng pimaluni.",
        "translation": "And this part had those between it where a person would be."
    },
    "74": {
        "startTime": 627.163,
        "endTime": 633.285,
        "transcript": "Uatii cali tamakucineng pimaluni cungqercecumaluni.",
        "translation": "And toward the door from there, it had those where a person would be."
    },
    "75": {
        "startTime": 633.967,
        "endTime": 641.512,
        "transcript": "Tau͡ga ataucimeng-ll' cungqerpegnateng enet tamakut pituluteng.",
        "translation": "Those houses wouldn't have just one person."
    },
    "76": {
        "startTime": 643.01,
        "endTime": 653.11,
        "transcript": "Wanigga taigurallemni ukani taukut civunerkiutulit teggenrurtellriit makut",
        "translation": "As I was coming, those who elders who would speak of the future"
    },
    "77": {
        "startTime": 653.787,
        "endTime": 659.153,
        "transcript": "Taukuk cali nallunarikagneng cimiryuumarkaulriarulutek",
        "translation": "If they become unnoticable, they can be changed"
    },
    "78": {
        "startTime": 660.302,
        "endTime": 665.609,
        "transcript": "Makuneng tan'gurrarneng civunerkiuritulit.",
        "translation": "The ones who speak of the future for these boys."
    },
    "79": {
        "startTime": 665.759,
        "endTime": 674.982,
        "transcript": "Makut tau͡gken kevgaraat arnat enaitni, enmeggni amani",
        "translation": "These women who would serve [their elders], however, in their houses over there"
    },
    "80": {
        "startTime": 674.998,
        "endTime": 677.987,
        "transcript": "Marrlugaita tau͡gaam caliaqluki.",
        "translation": "Their grandmothers instead worked on them."
    },
    "81": {
        "startTime": 677.99,
        "endTime": 685.123,
        "transcript": "Cali taukugtun tau͡ga-i qaneryaraatun atauciuguq wii cumigartaqama.",
        "translation": "It's one with the [men's] traditional wisdom when I look closely."
    },
    "82": {
        "startTime": 685.861,
        "endTime": 697.861,
        "transcript": "Una-wa maurluqenricaaqeka-llu, anaanaka una taukuneng al'qamneng qanerturaqeraqan",
        "translation": "She's not actually my grandmother, but when my maternal aunt spoke to my older sisters"
    },
    "83": {
        "startTime": 697.876,
        "endTime": 704.42,
        "transcript": "Ayuqsarpenaqapiarluku iluarullutek tau͡ga qaneryaraak tamana ayuqelliniuq.",
        "translation": "Their traditional wisdom is exacly the same and compliment each other."
    },
    "84": {
        "startTime": 704.423,
        "endTime": 712.245,
        "transcript": "Inerquutaat-ll' atauciuluni, alarquuteklengnaaraat cali atauciuluni.",
        "translation": "And their admonishments are one, and their instructions are also one."
    },
    "85": {
        "startTime": 713.296,
        "endTime": 718.374,
        "transcript": "Cameng alangaarnarqelriameng qaneryarameng niitnarqevkenateng.",
        "translation": "We do not hear any surprising traditional wisdom from them."
    },
    "86": {
        "startTime": 722.818,
        "endTime": 734.993,
        "transcript": "Tau͡gamtellu maa-i makuneng qantuut taukut, qantuut tamakut teggenrurtellriit",
        "translation": "Then now, they say, those elders say"
    },
    "87": {
        "startTime": 735.473,
        "endTime": 744.502,
        "transcript": "Wangkuta-gguq Cup'igni Kass'aneng caneng imkuneng avungeciqukut.",
        "translation": "They said that we Cuppot will get Westerners, other kinds [of people] among us."
    },
    "88": {
        "startTime": 744.833,
        "endTime": 753.691,
        "transcript": "Avungluta wangkucicetun ayuqenrilngurneng, wangkucicetun cuucingqenrilngurneng.",
        "translation": "They said that there will be among us people different from us, people with different lives from us."
    },
    "89": {
        "startTime": 753.871,
        "endTime": 757.014,
        "transcript": "Cunagg' makut Kass'at.",
        "translation": "It turned out to be these Caucasians."
    },
    "90": {
        "startTime": 757.562,
        "endTime": 771.42,
        "transcript": "Tau͡ga-ll' imkut Kass'am pekqaluteng pitullratni unani wangkutni yaaken Carvanertuliarmeng kingunerluteng Kuigpagmi",
        "translation": "Then back when those Caucasians traveled among us who where from over in Carvanertuliar on the Yukon"
    },
    "91": {
        "startTime": 772.608,
        "endTime": 781.823,
        "transcript": "Tamakut qantulliniut, \"Maa-i-gguq makut amllericiqut, amlleriinarciqut.\"",
        "translation": "They would say, \"There will be more of these people, more and more.\""
    },
    "92": {
        "startTime": 782.127,
        "endTime": 793.142,
        "transcript": "Kiitau͡gani-gguq wangkuta imutun Cup'igni tamani uitalriatun ellirtukut tamakut amllenrureskata.",
        "translation": "They said that we Cupiit would eventually be among different kinds if there are more of them [than us]."
    },
    "93": {
        "startTime": 793.152,
        "endTime": 798.523,
        "transcript": "Arenqiallugun cali tamakut amllenrureskata",
        "translation": "Also misfortune if there are more of them [than us]"
    },
    "94": {
        "startTime": 800.108,
        "endTime": 811.493,
        "transcript": "Arenqiallugutellernaq man'a ellaitni pisqumatkenrilnguq anlirluni amlleriluni",
        "translation": "What would cause us misfortune that they would not want upon us gets bigger and increases"
    },
    "95": {
        "startTime": 811.512,
        "endTime": 816.955,
        "transcript": "Qaillun wangkuta Cup'igni piyungramteki pisciigaliciqaput.",
        "translation": "No matter what we Cupiit want to do to them, we will be unable to [deal with] them."
    },
    "96": {
        "startTime": 817.601,
        "endTime": 825.685,
        "transcript": "Tau͡gaam wanigga assinguaraqua waten wanigg' qaneryaurcama, qanerteńgurrlua qaneryaurcama.",
        "translation": "But I am pretending to be good now as I started speaking, since I have started speaking as a teacher."
    },
    "97": {
        "startTime": 825.686,
        "endTime": 840.472,
        "transcript": "Pingraitkut tamakut acivanritengnaqluta. Wangkuta tamakut inglulingnaqluki pinertutacirramcetun piniaraput wangkuta.",
        "translation": "No matter what they do to us, let us not lower ourselves. Let us try to work with them as much as we can."
    },
    "98": {
        "startTime": 840.732,
        "endTime": 845.046,
        "transcript": "Ellaita man'a nunavut pikenritaat.",
        "translation": "They do not own our land."
    },
    "99": {
        "startTime": 845.234,
        "endTime": 854.805,
        "transcript": "Cali tamaani waten una Alaska-q una naken-lli pingraata, yaaqvaneng pingraata",
        "translation": "And here in Alaska, not matter where they're from, even if they come from far away"
    },
    "100": {
        "startTime": 855.082,
        "endTime": 866.025,
        "transcript": "Tau͡ga elluarrluki ikayungnaqaqait taukut nunat pikngamegteggu man'a tamalkuan ayuqluteng.",
        "translation": "They are trying to help those lands well because all of this belongs to each of them the same way."
    },
    "101": {
        "startTime": 867.597,
        "endTime": 877.254,
        "transcript": "Tau͡gaten tau͡gaam pinritniartukut wangkuta una nunavut pingraatgu.",
        "translation": "However, let us not do that though they do that to our land here."
    },
    "102": {
        "startTime": 879.233,
        "endTime": 885.061,
        "transcript": "Ikayuulluta Cup'igglugarni wangkuta piniartukut.",
        "translation": "Let us Cupiit help each other."
    },
    "103": {
        "startTime": 885.074,
        "endTime": 895.603,
        "transcript": "Ukegkut-llu tau͡ga cingumayaaqekenka kinguverkanka wii tau͡gaten tau͡ga pingraata tamakut akimatesqelluki.",
        "translation": "I also encourage my descendants to come that even if they do that to respond to them."
    },
    "104": {
        "startTime": 897.308,
        "endTime": 907.194,
        "transcript": "Waten nayurrlainarngailamki cali qaneryarameng tamakut tan'gurraat ayagyugaanka ikani Cev'ami.",
        "translation": "Since I will not always be with those boys, my young people, over in Chevak, I [tell them] my traditional wisdom."
    },
    "105": {
        "startTime": 907.204,
        "endTime": 915.419,
        "transcript": "School-arvia tumekluku waten qaneryaramkun piuratulqanka akaurtuq",
        "translation": "It's been a long time since I've passed on my traditional wisdom through their school"
    },
    "106": {
        "startTime": 915.44,
        "endTime": 930.283,
        "transcript": "Akaurtuq BIA-m, BIA-m aulukellraniu school-arvigput. Civuqlikacagauluta wangkuta tegulqerput Chevak-armiuni school-arvigput.",
        "translation": "It's been a long time since the BIA took care of our school. We from Chevak were the very first to take our school."
    },
    "107": {
        "startTime": 933.082,
        "endTime": 940.282,
        "transcript": "Tau͡ga-i-ll' tegukevut qaillukuange'rmegteggu-llu qaillukuarciiganaku.",
        "translation": "Then we took it, and no matter what they tried to do to it, they couldn't do anything."
    },
    "108": {
        "startTime": 940.292,
        "endTime": 956.22,
        "transcript": "Maa-i cali taukut ilallrenka imkut nallunarillret, icivaq-am caumatqallemni meeting-alrianun tamakunun Kass'anek inglulirluteng, school-arteńek inglulirluteng",
        "translation": "And my former peers who are not known know, when I was recently in a meeting along with Caucasians, along with the school officials"
    },
    "109": {
        "startTime": 957.772,
        "endTime": 968.587,
        "transcript": "Tauna kayukluki wii piamki tamakut, tayima [?] makunek [?ingllilrungraata] kayukluki wii keyirma.",
        "translation": "Since those were my source of strength, though they [?] these, I was the only one who had them as my source of strength."
    },
    "110": {
        "startTime": 968.607,
        "endTime": 973.95,
        "transcript": "Tau͡gaam tutgarameng imumeng [?] elicarangqertua.",
        "translation": "But I have taught one of my grandchildren."
    },
    "111": {
        "startTime": 974.637,
        "endTime": 982.323,
        "transcript": "Qanelqa tamana aturluku piuratuuq. Assirtuq.",
        "translation": "He does the things I say. He's good."
    },
    "112": {
        "startTime": 982.888,
        "endTime": 987.017,
        "transcript": "Waten tau͡ga piuralleq man'a, eglertengnaquralleq",
        "translation": "Doing this, trying to keep going"
    },
    "113": {
        "startTime": 987.189,
        "endTime": 1000.946,
        "transcript": "Ilani makut imkurluteng pingraata eglertengnaquralleq cali ayagyugaulriani",
        "translation": "Trying to keep going no matter what those around them do, to those who are young"
    },
    "114": {
        "startTime": 1001.212,
        "endTime": 1008.726,
        "transcript": "He is called, they call him this: he is a good person, he is good.",
        "translation": "He is called, they call him this: he is a good person, he is good."
    },
    "115": {
        "startTime": 1013.072,
        "endTime": 1015.143,
        "transcript": "Cameng ata aturyugciq...",
        "translation": "What will [?] want to use..."
    }
};